import isEmpty from 'lodash/isEmpty';
import pickBy from 'lodash/pickBy';

import { ContentMetadata } from '@candu-ai/content/types';
import { dismissLabelAdapter } from 'craft/containers/Craft/format/dismissAdapter';
import { ContentNode, CssSelectorDefinitions, CssSelectorId } from 'craft/types';

const backdropAdapter = (node: ContentNode) => {
  const { backdropCss, ...otherCustom } = node?.data?.custom ?? {};
  if (isEmpty(backdropCss)) {
    return node;
  }
  const backdropSelector = {
    ...CssSelectorDefinitions[CssSelectorId.ModalBackdrop],
    css: backdropCss,
  };
  const custom = pickBy(otherCustom);
  return {
    ...node,
    data: pickBy({
      ...node.data,
      custom: isEmpty(custom) ? undefined : custom,
    }),
    cssSelectors: {
      ...(node.cssSelectors ?? {}),
      [CssSelectorId.ModalBackdrop]: backdropSelector,
    },
  };
};

const labelAdapter = (node: ContentNode, nodeId: string, contentMetadata: ContentMetadata) => {
  const eventName = `DismissedModal ${contentMetadata?.slug || ''}`;
  return dismissLabelAdapter(eventName)(node);
};

export const modalAdapters = (
  node: ContentNode,
  nodeId: string,
  contentMetadata: ContentMetadata,
) => {
  return backdropAdapter(labelAdapter(node, nodeId, contentMetadata));
};
